import Lockr from 'lockr';
import { Tenant } from 'v2/core/entities/user';

// This file holds temporary solution for
// replacing source names for specific tenants. We can remove
// this file completely once `Source Name` project is released.

const replaceSourceNamesForFigma = (sourceName: string) => {
  if (
    sourceName.includes('Snowflake') &&
    sourceName.includes('CUSTOMER_FEEDBACK_TICKETS')
  ) {
    return sourceName
      .replace(/Snowflake\s?-?\s?CUSTOMER_FEEDBACK_TICKETS/g, 'Zendesk Tickets')
      .trim();
  }

  if (
    sourceName.includes('Snowflake') &&
    sourceName.includes('CUSTOMER_FEEDBACK_REVIEWS')
  ) {
    return sourceName
      .replace(/Snowflake\s?-?\s?CUSTOMER_FEEDBACK_REVIEWS/g, 'Asana (Go/VoC)')
      .trim();
  }

  if (sourceName.includes('Discourse')) {
    return sourceName.replace('Discourse', 'Community Forum');
  }

  return sourceName;
};

const replaceSourceNamesForMobilityADO = (sourceName: string) => {
  if (sourceName.includes('Experimento Daniel')) {
    return 'Encuestas de NPS';
  }

  return sourceName;
};

const replaceSourceNameForHSD = (sourceName: string) => {
  if (
    sourceName === 'FileUpload Rate-The-Ride' ||
    sourceName === 'Rate-The-Ride'
  ) {
    return sourceName.replace('Rate-The-Ride', 'Rate-The-Ride Testing');
  }
  return sourceName;
};

const replaceSourceNameForCanva = (sourceName: string) => {
  if (sourceName === 'FileUpload churn' || sourceName === 'churn') {
    return 'Canva Pro/Teams Churn Survey';
  }

  if (sourceName === 'FileUpload help_center' || sourceName === 'help_center') {
    return 'Help Center Article Feedback';
  }

  if (
    sourceName === 'FileUpload product_feedback_platform' ||
    sourceName === 'product_feedback_platform'
  ) {
    return 'Product Feedback Platform';
  }

  return sourceName;
};

export const replaceSourceNameForTenantIfRequired = (sourceName: string) => {
  const tenant: Tenant = Lockr.get('tenant');

  switch (tenant.slug) {
    case 'figma':
      return replaceSourceNamesForFigma(sourceName);
    case 'mobility-ado':
      return replaceSourceNamesForMobilityADO(sourceName);
    case 'hopskipdrive':
      return replaceSourceNameForHSD(sourceName);
    case 'canva':
      return replaceSourceNameForCanva(sourceName);
  }

  return sourceName;
};
